import React, { JSX } from 'react';
import { Flex, Heading } from '@chakra-ui/react';

type MainPageHeadingProps = {
  children: React.ReactNode;
};

const MainPageHeading = ({ children }: MainPageHeadingProps): JSX.Element => {
  return (
    <Heading variant="pageHeading" textAlign="left" ml={2} pt={3}>
      <Flex alignItems="center" gap={4}>
        {children}
      </Flex>
    </Heading>
  );
};

export default MainPageHeading;
